import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { EffectsModule } from '@ngrx/effects';
import { StoreRouterConnectingModule } from '@ngrx/router-store';
import { Action, Store, StoreModule } from '@ngrx/store';
import { Observable, timer } from 'rxjs';

import { syncAppState } from './+state/app.actions';
import { AppEffects } from './+state/app.effects';
import * as AppState from './+state/app.reducer';
import { GopherBuddyAppState } from './+state/app.state';
import { AppStateService } from './+state/services/app-state.service';
import { AppComponent } from './app.component';
import { appRoutes } from './app.routes';
import { DeviceInfoComponent } from './common/components/device-info/device-info.component';
import { GbFooterComponent } from './common/components/gb-footer/gb-footer.component';
import { HelpComponent } from './common/components/help/help.component';
import { LauncherComponent } from './common/external/launcher/launcher.component';
import { GbOptionsComponent } from './common/internal/gb-options/gb-options.component';
import { MaterialModule } from './common/material/material.module.ts/material/material.module';
import { UiService } from './common/services/ui.service';

@NgModule({
  declarations: [AppComponent, LauncherComponent, GbOptionsComponent],
  imports: [
    BrowserModule,
    RouterModule.forRoot(appRoutes),
    StoreModule.forRoot<GopherBuddyAppState, Action>(
      {
        [AppState.APP_FEATURE_KEY]: AppState.appReducer,
      },
      {
        metaReducers: [],
        runtimeChecks: {
          strictActionImmutability: true,
          strictStateImmutability: true,
        },
      }
    ),
    EffectsModule.forRoot([AppEffects]),
    StoreRouterConnectingModule.forRoot(),
    BrowserAnimationsModule,
    MaterialModule,
    GbFooterComponent,
    HelpComponent,
    DeviceInfoComponent,
  ],
  providers: [AppStateService, UiService],
  bootstrap: [AppComponent],
})
export class AppModule {
  private appStateSyncTimer$: Observable<number> = timer(5000, 10 * 1000);

  constructor(private appState: Store<GopherBuddyAppState>) {
    this.appStateSyncTimer$.subscribe(() => {
      appState.dispatch(syncAppState());
    });
  }
}
